/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorMessageRole } from './aiTutorMessageRole';

/**
 * Message in a conversation (API level).
 */
export interface AiTutorMessage {
  id: string;
  role: AiTutorMessageRole;
  content: string;
  createdAt?: string;
}
